export function jsonStringifyReplacer(key, value) {
    if (value === null) {
      return undefined;
    }
    if (value === ""){
      return undefined;
    }
    return value;
  }